import React from 'react';

export default React.forwardRef(({ children, style, className }, ref) => {
	return <div ref={ref} className={'card' + (className ? ' ' + className : '')} style={style}>
		{children}
	</div>;
});
